import { render, staticRenderFns } from "./mobileTabBar.vue?vue&type=template&id=e987e758&scoped=true"
import script from "./mobileTabBar.vue?vue&type=script&lang=js"
export * from "./mobileTabBar.vue?vue&type=script&lang=js"
import style0 from "./mobileTabBar.vue?vue&type=style&index=0&id=e987e758&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e987e758",
  null
  
)

export default component.exports